module.exports = __webpack_public_path__ + "img/primo-fruits_680x964.50712a21.jpg";